export default __webpack_public_path__ + "static/media/rs_school_js.4ef58c50.svg";